import React from "react";
// @ts-ignore
import FavouriteCard from "./FavouriteCard";
// @ts-ignore
import EmptyPage from "./emptyPage";
// @ts-ignore
import bgTop from "./../Assets/Images/bg-top.svg";
// @ts-ignore
import bgBottom from "./../Assets/Images/bg-bottom.png";

export interface BookMarkItem {
  id: string;
  isCollar?: boolean;
  videoId?: string;
  [key: string]: any; // Allow other properties for now
}

export interface FavouriteProps {
  bookMarks: BookMarkItem[];
  removeBookMark: (item: BookMarkItem) => void;
  utm_source: string;
}

const Favourite: React.FC<FavouriteProps> = (props) => {
  const { bookMarks, removeBookMark, utm_source } = props;

  return (
    <div className="position-relative">
      <img className="bg-top" src={bgTop} alt="bg top" />
      <div className="container-xxl my-4">
        <p className="fw-bold mt-5 font-21">Your Favourite Videos</p>
        {bookMarks && bookMarks.length > 0 ? (
          <div className="row">
            {bookMarks.map((item) => {
              return (
                <div
                  className="col-12 col-sm-6 col-md-4 my-3 col-xl-3"
                  key={item.id}
                >
                  <FavouriteCard
                    data={item}
                    removeBookMark={() => removeBookMark(item)}
                    utm_source={utm_source}
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <EmptyPage />
        )}
      </div>
      <img className="bg-bottom" src={bgBottom} alt="bg bottom" />
      <div style={{ height: 150 }}></div>
    </div>
  );
};

export default React.memo(Favourite);
